  /* IMPORTATION */

import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../assets/logo.svg';
import './navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);  //Pour lister le menu sur le cote si media Queries changent

  return (
    <div className="gpt3__navbar">
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <img src={logo} alt='logo' />
        </div>
        <div className="gpt3__navbar-links_container">
          <p><a href="#home">Acceuil</a></p>
          <p><a href="#wgpt3"> GPT3 c'est quoi?</a></p>
          <p><a href="#possibility">Open AI</a></p>
          <p><a href="#features">Études de cas</a></p>
          <p><a href="#blog">Bibliothèque</a></p>
        </div>
      </div>
      <div className="gpt3__navbar-sign">
        <p>Sign in</p>
        <button type="button">S'inscrire</button>
      </div>
      <div className="gpt3__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />   //Condition
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="gpt3__navbar-menu_container scale-up-center">
          <div className="gpt3__navbar-menu_container-links">
            <p><a href="#home">Acceuil</a></p>
            <p><a href="#wgpt3">GPT3 c'est quoi?</a></p>
            <p><a href="#possibility">Open AI</a></p>
            <p><a href="#features">Études de cas</a></p>
            <p><a href="#blog">Bibliothèque</a></p>
          </div>
          <div className="gpt3__navbar-menu_container-links-sign">
            <p>Se connecter</p>
            <button type="button">Se connecter</button>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;